import type { UserType } from '@shared/store/exchangeSlice';

const normalizeBase64 = (value: string) => {
  return value
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(value.length + ((4 - (value.length % 4)) % 4), '=');
};

export const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
  const tokenParts = token.split('.');

  if (tokenParts.length < 2) {
    return null;
  }

  try {
    const payload = tokenParts[1];
    if (!payload) {
      return null;
    }

    const decoded = atob(normalizeBase64(payload));
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return null;
  }
};

export const getUserTypeFromAccessToken = (token: string): UserType | null => {
  const payload = decodeJwtPayload(token);
  const candidateUserType = payload?.userType

  return typeof candidateUserType === 'string' ? (candidateUserType as UserType) : null;
};

export const getOrgIdFromAccessToken = (token: string): string | null => {
  const payload = decodeJwtPayload(token);
  const candidateOrgId = payload?.orgId ?? payload?.org_id;

  return typeof candidateOrgId === 'string' ? candidateOrgId : null;
};

export const getEmailFromAccessToken = (token: string): string | null => {
  const payload = decodeJwtPayload(token);
  const candidateEmail = payload?.email ?? payload?.sub;

  return typeof candidateEmail === 'string' ? candidateEmail : null;
};
